import React from 'react';
import './ToggleSwitch.css';
const generateInputAttributes = props => {
  const {
    id,
    name,
    checked,
    onChange,
    disabled
  } = props;
  const attrs = {
    type: 'checkbox',
    onChange,
    disabled,
    checked
  };
  if (id) {
    attrs.id = id;
  }
  if (name) {
    attrs.name = name;
  }
  return attrs;
};
function ToggleSwitch(props) {
  const {
    className,
    disabled
  } = props;
  const disabledClass = disabled ? 'disabled' : '';
  const additionalClass = className || '';
  const finalClass = `ToggleSwitch ${additionalClass}`.trim();
  const sliderClass = `ToggleSwitch-slider round ${disabledClass}`.trim();
  const inputAttribs = generateInputAttributes(props);
  return /*#__PURE__*/React.createElement("label", {
    className: finalClass
  }, /*#__PURE__*/React.createElement("input", inputAttribs), /*#__PURE__*/React.createElement("span", {
    className: sliderClass
  }));
}
ToggleSwitch.defaultProps = {
  className: '',
  disabled: false
};
export default ToggleSwitch;